import { ExecutiveAssociate } from './executive-associate.model';
import { TaxInfo, ITaxInfoContainer } from './tax-info.model';

export class Passenger implements ITaxInfoContainer {
  passengerId: number | null;
  reserved: boolean;
  taxInfo: TaxInfo[] = [];
  executiveAssociates: ExecutiveAssociate[] = [];
}

export const isPassengerSaved = (obj: Passenger) => {
  return obj.passengerId && obj.passengerId > 0;
};
